// extracted by mini-css-extract-plugin
module.exports = {"button":"CartItem_button__wBVb6","icon":"CartItem_icon__MOFUb","badge":"CartItem_badge__3B3eS","bump":"CartItem_bump__WH_tc"};